var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    { attrs: { dense: "" } },
    [
      _vm.selectedTab == "nodal"
        ? _c(
            "v-col",
            { attrs: { cols: "12", sm: "6" } },
            [
              _c(
                "Widget",
                {
                  attrs: { title: "Duck Curve - " + _vm.nodeName },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "append-title",
                        fn: function () {
                          return [
                            _c(
                              "v-card",
                              { attrs: { flat: "", width: "120" } },
                              [
                                _c("v-autocomplete", {
                                  attrs: {
                                    outlined: "",
                                    label: "MM-DD",
                                    items: _vm.dayItems,
                                    dense: "",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.duckCurveDate,
                                    callback: function ($$v) {
                                      _vm.duckCurveDate = $$v
                                    },
                                    expression: "duckCurveDate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    3819087100
                  ),
                },
                [
                  _vm.duckCurve.data.length
                    ? _c("Plotly", {
                        attrs: {
                          data: _vm.duckCurve.data,
                          layout: _vm.duckCurve.layout,
                        },
                      })
                    : _c(
                        "v-card",
                        {
                          staticClass: "d-flex align-center justify-center",
                          attrs: { flat: "", height: "400" },
                        },
                        [
                          _c(
                            "v-card-text",
                            { staticClass: "text-center text-subtitle-1" },
                            [
                              _vm._v(
                                " Time series results required for duck curve "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._l(_vm.charts, function (chart, index) {
        return _c(
          "v-col",
          { key: "" + index + chart, attrs: { cols: "12", sm: "6" } },
          [
            _c(
              "Widget",
              {
                attrs: {
                  title: chart.title + " - " + _vm.nodeName,
                  height: "100%",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "append-title",
                      fn: function () {
                        return [
                          _c(
                            "v-col",
                            { staticClass: "pa-0" },
                            [
                              chart.title === "Generation Mix" ||
                              chart.title === "Generation Mix by Fuel"
                                ? _c("v-select", {
                                    attrs: {
                                      label: "Year",
                                      items: _vm.outputYears,
                                      "item-text": "title",
                                      "item-value": "value",
                                      width: "100",
                                      "hide-details": "",
                                      outlined: "",
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.generationMixYear,
                                      callback: function ($$v) {
                                        _vm.generationMixYear = $$v
                                      },
                                      expression: "generationMixYear",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              },
              [
                _c("Plotly", {
                  attrs: {
                    data: chart.data,
                    layout: _vm.chartLayout(chart.layout),
                    toImageButtonOptions: _vm.chartDownloadName(
                      _vm.caseName,
                      "PC",
                      chart.layout.title
                    ),
                  },
                }),
              ],
              1
            ),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }